import React from 'react';
import styled from 'styled-components';
import QRCode from 'qrcode.react';


const StyledQR = styled.div`
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px auto;
`


const QRCodeComp = ({link, size}) => {
   return (
       <StyledQR>
           <QRCode value={link || ''} size={size}/>
       </StyledQR>
   )
};

export default QRCodeComp;

